module.exports = __webpack_public_path__ + "img/Frame6.475283da.png";